import React from 'react';
import { connect } from 'react-redux';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { formatarReal } from '../../util/numberUtil';
import ReactTooltip from 'react-tooltip';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getGestorEmpresa,
} from '../../security/securityContext';
import selecionarPedido from '../../actions/pedido/selecionarPedido';

export const Cabecalho = () => (
  <div className="lista-eventos titulo">
    <div className="row cabecalho-desktop">
      <div className="col-12 col-sm-12 col-md-2">Data e Hora</div>
      <div className="col-12 col-sm-12 col-md-2">Situação</div>
      <div className="col-12 col-sm-12 col-md-3">Usuário</div>
      <div className="col-12 col-sm-12 col-md-3">Observação</div>
      <div className="col-12 col-sm-12 col-md-2">Valor de estorno</div>
    </div>
  </div>
);

export class ModalHistoricoPedido extends React.Component {


  limpar() {
    this.props.selecionarPedido(null);
  }

  possuiReservasCanceladas() {
    return this.props.pedido.reservas.filter(r => r.situacaoReserva === 'CANCELADO').length > 0;
  }

  possuiHistoricoPedidoCancelado(historico) {
    return this.possuiReservasCanceladas() &&
      (historico.situacaoPedido === 'CANCELADO' || historico.situacaoPedido === 'CANCELADO_REMARCADO_PARCIALMENTE' ||
        historico.situacaoPedido === 'CANCELADO_REMARCADO')
  }

  exibirAnotacaoInternaReserva() {
    const reservasCanceladas = this.props.pedido.reservas.filter(it => it.situacaoReserva == 'CANCELADO')
    return <span className="align-self-center tooltip-info">
      <a data-tip data-for="anotacao-interna">
        <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
      </a>
      <div className="tooltip-ut">
        <ReactTooltip className="tooltip-ut" id="anotacao-interna" type="dark" effect="solid">
          <div className="row">Anotação interna:&nbsp; {reservasCanceladas.map(it => <p key={`observacao-${it.id}`}>{it.observacao}</p>)}</div>
        </ReactTooltip>
      </div>
    </span>
  }

  exibirHistorico() {
    if (this.props.pedido && this.props.pedido.historicos) {
      return this.props.pedido.historicos.map(historico => <div className="lista-eventos" key={`${historico.cod}-${historico.dataHora}`}>
        <div className="row conteudo-desktop">
          <div className="col-12 col-sm-12 col-md-2">
            <div id="data-hora" className="texto"><p>{historico.dataHora}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-2">
            <div id="evento" className="texto">
              <p>{historico.descricaoSituacao}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3">
            <div id="usuario" className="texto">
              <p>{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3">
            <div id="documentos" className="texto">
              <p>{historico.observacao ? historico.observacao : '-'}</p>
            </div>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
              getGestorEmpresa(this.props.empresaSelecionada.id),
              getAdminEmpresa(this.props.empresaSelecionada.id)]}>
              <div>
                {this.possuiHistoricoPedidoCancelado(historico) ? <div>{this.exibirAnotacaoInternaReserva()}</div> : ''}
              </div>
            </Autorizacao>
          </div>
          <div className="col-12 col-sm-12 col-md-2">
            <div id="estorno" className="texto">
              {this.possuiHistoricoPedidoCancelado(historico) ? <p>{formatarReal(this.props.pedido.valorEstorno)}</p> : '-'}
            </div>
          </div>
        </div>
      </div>)
    }
    return ''
  }

  render() {
    return (

      <div className="modal fade show" role="dialog"
        id="modalHistoricoPedido" aria-labelledby="modalHistoricoPedido" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-info modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Pedido {this.props.pedido ? this.props.pedido.id : ''}</h3>
              <button type="button" className="close" data-dismiss="modal" id="btnFecharmodalHistoricoPedido"
                aria-label="Close" onClick={() => this.limpar()}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body corpo-modal">
              <Cabecalho />
              {this.exibirHistorico()}
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export function mapStateToProps(state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    pedido: state.pedido
  }
}

export default connect(mapStateToProps,
  {
    selecionarPedido
  })(ModalHistoricoPedido)
